import { EVehicleType } from '@okcargo-apps/shared-domain';

export interface IVehicleFormValue {
  plateNumber: string;
  type: EVehicleType;
}

export interface IVehicleTypeOption {
  type: EVehicleType;
  labelKey: string;
}

/** Object id used by the messages-ui service to show messages about the vehicles list. */
export const VEHICLES_LIST_MESSAGE_OBJECT_ID = 'vehicles-list';

export const VEHICLE_TYPE_OPTIONS: readonly IVehicleTypeOption[] = [
  { type: EVehicleType.TRACTOR, labelKey: 'vehicles.types.tractor' },
  { type: EVehicleType.CANVAS, labelKey: 'vehicles.types.canvas' },
  { type: EVehicleType.BOX, labelKey: 'vehicles.types.box' },
];
